import React from 'react';

import hintStartHereImg from '../images/hint-start-here.svg';

const Instructions = () => {
  return (
    <div className="instructions">
      <img className="instructions-hint-start-here" src={hintStartHereImg} alt="start" />
    </div>
  );
};

export default Instructions;
